import { cn } from '@/lib/utils'
import styles from '@/components/assets-explorer/assets-explorer.module.scss'
import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

export const subCategoriesGridVariants = cva(styles.assetGallerySlider, {
  variants: {
    aspect: {
      default: 'tw-aspect-ultra-wide',
      wide: 'tw-aspect-video',
      square: 'tw-aspect-square',
    },
  },
  defaultVariants: {
    aspect: 'default',
  },
})

export type ContentsGridSkeletonProps = VariantProps<typeof subCategoriesGridVariants> & {
  className?: string
  withTitle?: boolean
}

export default function SubCategoriesGridSkeleton({ aspect, className, withTitle }: ContentsGridSkeletonProps) {
  return (
    <>
      {withTitle && <Skeleton className="tw-mb-4 tw-h-6 tw-w-16" />}
      <ul
        className={cn(
          styles.assetGallery,
          {
            [styles.imageGallery]: aspect === 'square',
          },
          className
        )}
      >
        {Array.from({ length: 3 }).map((_, index) => (
          <li key={index}>
            <Skeleton className={cn(subCategoriesGridVariants({ aspect }))} />
          </li>
        ))}
      </ul>
    </>
  )
}
